import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import textUtil from '../../util/text';
import { formatWorkDuration } from '../../util/dates';

// The details of one item: a dot's accordion on the scatterplot and a row of the percentile items panel show them
export class CardDetails extends React.Component {
  renderDetail(d, y, bl, blockedTime, label, blockers) {
    const ct = formatWorkDuration(d.cycleTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays);
    const blockedList = _.find(bl, { listId: d.listId });
    const showBlockerInfo = blockers !== false && blockedTime === 'all';

    return (
      <p key={y}>
        {label}{' '}{d.list}: {ct}{' '}
        {showBlockerInfo && !!blockedList && (
          <span>
            {' '}
            {d.list} blocked time:{' '}
            {formatWorkDuration(blockedList.blockedTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}{' '}
          </span>
        )}{' '}
      </p>
    );
  }

  render() {
    const { point, blockedTime, blockers } = this.props;
    const showBlockerInfo = blockers !== false;
    const label = showBlockerInfo && blockedTime == 'blocked' ? 'Blocked ' : '';

    return (
      <React.Fragment>
        {!!point.card.coloredField && (
          <p>
            {textUtil.format(point.card.coloredField, null, false, false, 'capitalize')}:{' '}
            {point.card.coloredValue}
          </p>
        )}
        <p>
          {label} Cycle time:{' '}
          {formatWorkDuration(_.sumBy(point.details, 'cycleTime'), this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}
        </p>

        {showBlockerInfo && blockedTime === 'all' && !!point.card.blockedTime && (
          <p className="block-item">
            Blocked time:{' '}
            {formatWorkDuration(point.card.blockedTime, this.props.excludeWeekendOpts, this.props.timePrecision, this.props.useWorkingHoursInCycleTimeDays)}
          </p>
        )}
        {point.details.map((d, y) => {
          return this.renderDetail(d, y, point.card.blockedLists, blockedTime, label, blockers);
        })}
        {!!point.card.url && (
          <p>
            <a href={point.card.url} target="_blank" className="btn btn-sm btn-light-secondary">
              Open in {this.props.app !== 'file' ? this.props.appName : 'new tab'}
            </a>
          </p>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app.app,
    appName: state.app.appName,
    timePrecision: state.filters.timePrecision,
    excludeWeekendOpts: {
      type: state.filters.excludeWeekends,
      workStart: state.filters.workStart,
      workEnd: state.filters.workEnd,
      holidays: state.filters.holidays
    },
    useWorkingHoursInCycleTimeDays: state.auth.user.config && state.auth.user.config.useWorkingHoursInCycleTimeDays
  };
};

export default connect(mapStateToProps)(CardDetails);
